export default __webpack_public_path__ + "media/alVid.aba51407.mp4";